import { el, escape } from './dom';

export type DetectionRow = { name: string; method: string };

export type DetectionTableProps = {
  rows?: DetectionRow[];
};

export const DEFAULT_ROWS: DetectionRow[] = [
  { name: 'names', method: 'NER model' },
  { name: 'email addresses', method: 'regex' },
  { name: 'phone numbers', method: 'regex · intl' },
  { name: 'street addresses', method: 'NER + regex' },
  { name: 'social security numbers', method: 'regex' },
  { name: 'credit cards', method: 'regex · Luhn' },
  { name: 'bank accounts', method: 'regex · IBAN' },
  { name: 'dates of birth', method: 'regex + context' },
  { name: "driver's licenses", method: 'NER + regex' },
  { name: 'passport numbers', method: 'regex' },
  { name: 'IP addresses', method: 'regex · v4 · v6' },
  { name: 'API keys', method: 'pattern match' },
];

export const DetectionTable = (props: DetectionTableProps = {}): HTMLElement => {
  const rows = props.rows ?? DEFAULT_ROWS;
  const rowsHtml = rows
    .map(
      (r, i) => `
        <div class="catch-row">
          <div class="num">${String(i + 1).padStart(2, '0')}</div>
          <div class="name">${escape(r.name)}</div>
          <div class="method">${escape(r.method)}</div>
        </div>`,
    )
    .join('');

  return el(`
    <section class="caught" id="caught">
      <div class="container">
        <div class="section-header">
          <span class="label">what we catch</span>
          <h2>${rows.length === DEFAULT_ROWS.length ? 'twelve' : String(rows.length)} detection types, all running locally<span class="accent-period">.</span></h2>
        </div>
        <div class="catch-table">${rowsHtml}</div>
        <div class="catch-caption">works in 100+ languages</div>
      </div>
    </section>
  `);
};
